import { jsx as r } from "react/jsx-runtime";
import * as m from "react";
import { cn as e } from "../../../lib/utils.mjs";
import { PaginationContentVariants as s } from "./PaginationContentVariants.mjs";
const f = m.forwardRef(({ className: t, children: a, variant: o, ...n }, i) => /* @__PURE__ */ r(
  "ul",
  {
    ref: i,
    className: e(
      s({
        variant: o,
        className: t
      })
    ),
    ...n,
    children: a
  }
));
f.displayName = "PaginationContent";
export {
  f as default
};
//# sourceMappingURL=PaginationContent.mjs.map
